<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="unit"
                :options="unitOptions"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-width" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'width',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Width',
            tailwindDefinitionProp: 'width',
            defaultUnit: 'auto',
        };
    },
};
</script>
